import { ParcellaGiudiziale } from './parcella-giudiziale';
import { ParcellaStragiudiziale } from './parcella-stragiudiziale';
import { SoggettoPratica } from './tipologiche/soggetto-pratica';

export class ParcellaSoggetto {
    id: string;
    parcella: ParcellaGiudiziale | ParcellaStragiudiziale;
    soggetto: SoggettoPratica;
    percentualeParcella: number;
}
